// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import IDocCommandEnumValue from "./IDocCommandEnumValue";

export default interface IDocCommandEnum {
  values: IDocCommandEnumValue[];
  name: string;
}
